export const RESET = 'EXSBPERIODTYPE_UPDATE_RESET'
export const SET_ERROR = 'EXSBPERIODTYPE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBPERIODTYPE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBPERIODTYPE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBPERIODTYPE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBPERIODTYPE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBPERIODTYPE_UPDATE_UPDATE_RETRIEVED'
